import React, {
  useEffect,
  useMemo,
  useState,
  useCallback,
  useRef,
} from "react";

import SelectCliente from "../components/ui/selectCliente";
import "../sass/pages/chamados.scss";
import NovoChamadoModal from "../components/modalNovoChamado";
import { api } from "../api";
import { showInfo, showError } from "../utils/toast";
import MainLayout from "../components/mainLayout";
import ModalParcelas from "../components/modalParcelas";
import ModalPlanos from "../components/modalPlanos";
import ModalNumeroSerie from "../components/modalNumeroDeSerie";
import ModalHistoricoChamados from "../components/modalHistoricoChamados";
import ModalDataTolerancia from "../components/modalDataTolerancia";
import ModalConverterChamadoProjeto from "../components/modalConverterChamadoProjeto";
import ModalResultadoRetornoProjeto from "../components/modalResultadoRetornoProjeto";

const SETORES = [
  { value: "SUPORTE", label: "SUPORTE (fila geral)" },
  { value: "FINANCEIRO", label: "FINANCEIRO" },
  { value: "PROGRAMAÇÃO", label: "PROGRAMAÇÃO" },
  { value: "HARDWARE", label: "HARDWARE" },
  { value: "SERVIÇOS GERAIS", label: "SERVIÇOS GERAIS" },
  { value: "ENTREGADOR", label: "ENTREGADOR" },
];

const ROTA_CADASTRO_CLIENTE = "/cadastros";

const normStr = (v) => (v == null ? "" : String(v).trim());

const normSetor = (s) => {
  const t = normStr(s);
  if (!t) return "SUPORTE";
  return t.toUpperCase() === "SUPORTE" ? "SUPORTE" : t.toUpperCase();
};

const textoIgual = (a, b) =>
  normStr(a).toUpperCase() === normStr(b).toUpperCase();

const isRetornoProjeto = (chamado) =>
  normStr(chamado?.DM_ORIGEM ?? chamado?.dmOrigem).toUpperCase() ===
  "RETORNO_PROJETO";

const getProjetoOrigemChamado = (chamado) =>
  chamado?.ID_PROJETO_ORIGEM ?? chamado?.idProjetoOrigem ?? null;

const compactObject = (obj = {}) =>
  Object.fromEntries(
    Object.entries(obj).filter(([, value]) => {
      if (value === undefined || value === null) return false;
      if (typeof value === "string" && value.trim() === "") return false;
      return true;
    }),
  );

const getSessionValue = (...keys) => {
  for (const key of keys) {
    const value = normStr(sessionStorage.getItem(key));
    if (value) return value;
  }
  return "";
};

const isNivelGerencial = (nivel) => {
  const n = normStr(nivel).toUpperCase();
  return ["ADM", "GERENTE", "GESTOR", "SUPERVISOR"].includes(n);
};

const getApiErrorMessage = (error, fallback) =>
  error?.response?.data?.message ||
  error?.response?.data?.mensagem ||
  error?.response?.data?.erro ||
  error?.message ||
  fallback;

const URG_LABEL = {
  0: "Não urgente",
  1: "Pouco urgente",
  2: "Urgente",
  3: "Muito urgente",
  4: "Emergência",
};

const FILTROS_RAPIDOS = [
  { value: "TODOS", label: "Todos" },
  { value: "PENDENTES", label: "Pendentes" },
  { value: "EM_ATENDIMENTO", label: "Em atendimento" },
  { value: "CRITICOS", label: "Críticos" },
  { value: "SEM_DONO", label: "Sem dono" },
  { value: "MAIS_30", label: "+30 min" },
  { value: "WEB", label: "WEB" },
  { value: "LOCAL", label: "LOCAL" },
  { value: "SPW", label: "SPW" },
];

const getResumoPendenciasFinanceiras = (parcelas = []) => {
  const lista = Array.isArray(parcelas) ? parcelas : [];

  return lista.reduce(
    (acc, parcela) => {
      const situacao = normStr(
        parcela?.situacao ?? parcela?.Situacao ?? parcela?.SITUACAO,
      ).toUpperCase();
      const quitada = ["Q", "QUITADO", "QUITADA", "PAGO", "PAGA"].includes(
        situacao,
      );

      if (quitada) return acc;

      const atrasoRaw = parcela?.atrasado ?? parcela?.Atrasado ?? false;
      const atrasada =
        atrasoRaw === true ||
        atrasoRaw === 1 ||
        ["1", "true", "s", "sim"].includes(normStr(atrasoRaw).toLowerCase());

      if (atrasada) {
        acc.atrasadas += 1;
      } else {
        acc.emAberto += 1;
      }

      return acc;
    },
    { atrasadas: 0, emAberto: 0 },
  );
};

const Chamados = () => {
  const [chamadosPendentes, setChamadosPendentes] = useState([]);
  const [chamadosEmAtendimento, setChamadosEmAtendimento] = useState([]);
  const [chamadosFilaTecnicos, setChamadosFilaTecnicos] = useState([]);
  const [abaAtiva, setAbaAtiva] = useState("pendentes");

  const [tecnicosDisponiveis, setTecnicosDisponiveis] = useState([]);
  const [chamadoSelecionado, setChamadoSelecionado] = useState(null);
  const [detalhesChamado, setDetalhesChamado] = useState(null);

  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [parcelasCliente, setParcelasCliente] = useState({
    parcelas: [],
    totalGeral: "0,00",
    totalAtrasado: "0,00",
  });
  const [planosCliente, setPlanosCliente] = useState([]);

  const [descricaoModalAberto, setDescricaoModalAberto] = useState(false);
  const [novaDescricao, setNovaDescricao] = useState("");
  const [modalNovoChamadoAberto, setModalNovoChamadoAberto] = useState(false);
  const [tecnicoDestino, setTecnicoDestino] = useState("");
  const [tecnicoFiltroFila, setTecnicoFiltroFila] = useState("TODOS");
  const [confirmacaoNovoChamado, setConfirmacaoNovoChamado] = useState(null);

  const [mostrarModalParcelas, setMostrarModalParcelas] = useState(false);
  const [mostrarModalPlanos, setMostrarModalPlanos] = useState(false);
  const [mostrarModalNumeroSerie, setmostrarModalNumeroSerie] = useState(false);
  const [modalHistoricoAberto, setModalHistoricoAberto] = useState(false);
  const [isSubmittingDescricao, setIsSubmittingDescricao] = useState(false);
  const [isSubmittingFinalizar, setIsSubmittingFinalizar] = useState(false);
  const [codigoHistoricoCliente, setCodigoHistoricoCliente] = useState(null);
  const [mostrarModalTolerancia, setMostrarModalTolerancia] = useState(false);
  const [qtdParcelasAtrasadas, setQtdParcelasAtrasadas] = useState(0);
  const [clienteOption, setClienteOption] = useState(null);

  const [isIntervindo, setIsIntervindo] = useState(false);
  const [acaoIntervencao, setAcaoIntervencao] = useState("ASSUMIR");
  const [tecnicoDestinoAdm, setTecnicoDestinoAdm] = useState("");
  const [descricaoIntervencao, setDescricaoIntervencao] = useState("");
  const [isSubmittingIntervencao, setIsSubmittingIntervencao] = useState(false);
  const [isAcaoChamadoLoading, setIsAcaoChamadoLoading] = useState(false);

  const [modalConverterProjetoAberto, setModalConverterProjetoAberto] =
    useState(false);
  const [modalResultadoRetornoAberto, setModalResultadoRetornoAberto] =
    useState(false);
  const [setorDestinoChamado, setSetorDestinoChamado] = useState("");
  const [isSubmittingSetor, setIsSubmittingSetor] = useState(false);

  const [sortConfig, setSortConfig] = useState({
    key: "slaScore",
    direction: "desc",
  });

  const [descSempreVisivel, setDescSempreVisivel] = useState(
    () => localStorage.getItem("descSempreVisivel") === "1",
  );

  const [linhasAbertas, setLinhasAbertas] = useState(new Set());
  const [cardsAbertosMobile, setCardsAbertosMobile] = useState(new Set());
  const [filtroRapido, setFiltroRapido] = useState("TODOS");
  const [termoBusca, setTermoBusca] = useState("");
  const [ultimaAtualizacao, setUltimaAtualizacao] = useState(null);
  const [agoraTick, setAgoraTick] = useState(Date.now());

  // Novo UX: blocos colapsáveis
  const [kpisAbertos, setKpisAbertos] = useState(true);
  const [filtrosAbertos, setFiltrosAbertos] = useState(false);

  const funcionario = getSessionValue("RazaoSocial", "Funcionario", "funcionario");

  const userJson = (() => {
    try {
      return JSON.parse(sessionStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  })();

  const setorUsuario = normSetor(
    userJson.setor ??
      userJson.Setor ??
      userJson.setorFunc ??
      userJson.SetorFunc ??
      sessionStorage.getItem("Setor") ??
      sessionStorage.getItem("setor") ??
      sessionStorage.getItem("SetorFunc"),
  );

  const nivelUsuario = (
    userJson.Nivel ??
    userJson.NivelFunc ??
    userJson.nivel ??
    userJson.nivelFunc ??
    sessionStorage.getItem("NivelFunc") ??
    sessionStorage.getItem("NiveFunc") ??
    sessionStorage.getItem("nivelFunc") ??
    ""
  )
    .toString()
    .toUpperCase();

  const isAdmin = nivelUsuario === "ADM";
  const isGerencial = isNivelGerencial(nivelUsuario);
  const isSuporte = setorUsuario === "SUPORTE";
  const podeMoverSetor = isAdmin || isSuporte;

  const setoresDestinoPermitidos = useMemo(() => {
    if (isAdmin) return SETORES;
    if (isSuporte) {
      return SETORES.filter((item) => item.value === "FINANCEIRO");
    }
    return [];
  }, [isAdmin, isSuporte]);

  const [setorFiltro, setSetorFiltro] = useState(() => {
    const setorSalvo = normStr(sessionStorage.getItem("setorFiltro"));

    if (isGerencial && setorSalvo) {
      return normSetor(setorSalvo);
    }

    return setorUsuario;
  });

  useEffect(() => {
    sessionStorage.setItem("setorFiltro", setorFiltro);
  }, [setorFiltro]);

  useEffect(() => {
    localStorage.setItem("descSempreVisivel", descSempreVisivel ? "1" : "0");
  }, [descSempreVisivel]);

  useEffect(() => {
    const interval = setInterval(() => setAgoraTick(Date.now()), 60000);
    return () => clearInterval(interval);
  }, []);

  const toggleLinha = (id) => {
    setLinhasAbertas((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleMobileCard = (id) => {
    const key = String(id ?? "");
    if (!key) return;

    setCardsAbertosMobile((prev) => {
      const next = new Set(prev);

      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }

      return next;
    });
  };

  const isCollapsible = !descSempreVisivel;
  const showAtendente = abaAtiva !== "pendentes";
  const canTakeFromCurrentQueue = isAdmin || setorUsuario === normSetor(setorFiltro);

  const normalizeServidorWeb = (v) => {
    if (v == null) return "";
    const n = String(v).trim().toLowerCase();
    if (n === "spw") return "SPW";
    if (n === "web" || n === "nuvem" || n === "cloud") return "web";
    if (n === "local" || n === "onprem" || n === "on-premise") return "local";
    return String(v).trim();
  };

  const parseDateHoraBR = (data, hora = "") => {
    if (!data) return 0;

    const dataStr = String(data).trim();
    const horaStr = String(hora || "").trim();

    const textoCompleto = horaStr ? `${dataStr} ${horaStr}` : dataStr;

    const m = textoCompleto.match(
      /^(\d{2})\/(\d{2})\/(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?/,
    );

    if (m) {
      const [, dd, mm, yyyy, HH = "00", MM = "00", SS = "00"] = m;

      return new Date(
        Number(yyyy),
        Number(mm) - 1,
        Number(dd),
        Number(HH),
        Number(MM),
        Number(SS),
      ).getTime();
    }

    const t = Date.parse(textoCompleto);
    return Number.isNaN(t) ? 0 : t;
  };

  const minutosDesde = (data, hora = "") => {
    const ts = parseDateHoraBR(data, hora);
    if (!ts) return 0;

    return Math.max(0, Math.floor((agoraTick - ts) / 60000));
  };

  const formatarTempoAberto = (minutos) => {
    if (!minutos || minutos < 1) return "agora";
    if (minutos < 60) return `${minutos} min`;

    const h = Math.floor(minutos / 60);
    const m = minutos % 60;

    if (h < 24) return `${h}h${String(m).padStart(2, "0")}`;

    const d = Math.floor(h / 24);
    const rh = h % 24;

    return `${d}d ${rh}h`;
  };

  const getSlaInfo = (chamado) => {
    const minutos = minutosDesde(chamado?.Data, chamado?.Hora || chamado?.hora);
    const semDono = !normStr(chamado?.TecAtendimento);
    const urgencia = Number(chamado?.urgencia) || 0;

    let status = "normal";
    let label = "No prazo";
    let peso = minutos;

    if (minutos >= 120 || urgencia >= 4) {
      status = "critico";
      label = "Crítico";
      peso += 300;
    } else if (minutos >= 60 || urgencia >= 3) {
      status = "alto";
      label = "Atrasado";
      peso += 200;
    } else if (minutos >= 30 || urgencia >= 2) {
      status = "medio";
      label = "Atenção";
      peso += 100;
    }

    if (semDono && abaAtiva === "pendentes") {
      peso += 80;
    }

    return {
      minutos,
      tempo: formatarTempoAberto(minutos),
      status,
      label,
      semDono,
      score: peso,
    };
  };

  const normalizeChamado = (c) => {
    const get = (...ks) => {
      for (const k of ks) {
        const v = c?.[k];
        if (v != null && String(v).trim() !== "") return String(v).trim();
      }
      return "";
    };

    const CodigoCad = get(
      "CodigoCad",
      "codigoCad",
      "ChvCad",
      "chvCad",
      "CODIGO_CAD",
    );

    const RazaoSocial = get(
      "RazaoSocial",
      "RAZAO_SOCIAL",
      "razaoSocial",
      "Razao",
      "Cliente",
      "ClienteRazao",
      "Razao_Social",
      "NOME_RAZAO",
    );

    const NomeFant = get(
      "NomeFant",
      "NOME_FANTASIA",
      "nomeFantasia",
      "NomeFantasia",
      "Fantasia",
      "ClienteFantasia",
    );

    const setorRaw = c.setor ?? c.Setor ?? null;

    return {
      ...c,
      CodigoCad,
      ChvCad: get("ChvCad", "chvCad") || CodigoCad,
      RazaoSocial,
      NomeFant,
      ServidorWeb: normalizeServidorWeb(
        c.ServidorWeb ??
          c.servidorWeb ??
          c.Servidor ??
          c.TipoSistema ??
          c.tipoSistema ??
          "",
      ),
      Setor: setorRaw,
      setorNorm: normSetor(setorRaw),
      ID_PROJETO_ORIGEM:
        c.ID_PROJETO_ORIGEM ?? c.idProjetoOrigem ?? null,
      ID_CHAMADO_PAI: c.ID_CHAMADO_PAI ?? c.idChamadoPai ?? null,
      DM_ORIGEM: c.DM_ORIGEM ?? c.dmOrigem ?? null,
      NR_CICLO_PROJETO:
        c.NR_CICLO_PROJETO ?? c.nrCicloProjeto ?? null,
    };
  };

  const normalizeCliente = (cli = {}) => {
    const get = (...ks) => {
      for (const k of ks) {
        const v = cli?.[k];
        if (v != null && String(v).trim() !== "") return String(v).trim();
      }
      return "";
    };

    const CodigoCad = get(
      "CodigoCad",
      "codigoCad",
      "codigo",
      "ChvCad",
      "chvCad",
      "CODIGO_CAD",
      "value",
    );

    const RazaoSocial = get(
      "RazaoSocial",
      "RAZAO_SOCIAL",
      "razao",
      "razaoSocial",
      "Razao",
      "Cliente",
      "Razao_Social",
      "NOME_RAZAO",
      "nome",
    );

    const NomeFant = get(
      "NomeFant",
      "NomeFantasia",
      "NOME_FANTASIA",
      "nomeFantasia",
      "fantasia",
      "ClienteFantasia",
    );

    const telefones = get("telefones", "Tel1", "Tel2");
    const enderecoLinha1 = get("enderecoLinha1", "EnderecoLinha1", "Endereco");
    const enderecoLinha2 = get(
      "enderecoLinha2",
      "EnderecoLinha2",
      "BairroCidadeCep",
    );

    return {
      ...cli,
      CodigoCad,
      RazaoSocial,
      NomeFant,
      telefones,
      enderecoLinha1,
      enderecoLinha2,
    };
  };

  const marcarAtualizado = () => {
    setUltimaAtualizacao(new Date());
  };

  const fetchChamadosPendentes = async (setorOverride = setorFiltro) => {
    try {
      const setorConsulta = normSetor(setorOverride);

      const payload = compactObject({
        funcionario,
        setor: setorConsulta === "SUPORTE" ? undefined : setorConsulta,
      });

      const { data } = await api.post("/chamados", payload);
      setChamadosPendentes((data.chamados || []).map(normalizeChamado));
      marcarAtualizado();
    } catch (err) {
      console.error(
        "Erro ao buscar chamados pendentes:",
        getApiErrorMessage(err, "Erro ao buscar chamados pendentes."),
      );
    }
  };

  const fetchChamadosEmAtendimento = async () => {
    try {
      const { data } = await api.get("/chamados", { params: { funcionario } });
      const base = (data.chamados || []).map(normalizeChamado);

      const faltantes = base.filter(
        (x) => (!x.RazaoSocial || !x.NomeFant) && (x.CodigoCad || x.ChvCad),
      );

      const poolSize = 5;
      let i = 0;

      await Promise.all(
        Array.from({ length: Math.min(poolSize, faltantes.length) }).map(
          async () => {
            while (i < faltantes.length) {
              const item = faltantes[i++];
              const codigo = item.CodigoCad || item.ChvCad;
              if (!codigo) continue;

              try {
                const cli = await api.get("/cliente/por-codigo", {
                  params: { codigo },
                });

                const cliData = cli?.data || {};

                item.RazaoSocial =
                  item.RazaoSocial ||
                  cliData.RazaoSocial ||
                  cliData.razao ||
                  cliData.nome ||
                  "";

                item.NomeFant =
                  item.NomeFant ||
                  cliData.NomeFant ||
                  cliData.NomeFantasia ||
                  cliData.fantasia ||
                  "";
              } catch (_) {}
            }
          },
        ),
      );

      setChamadosEmAtendimento(base);
      marcarAtualizado();
    } catch (error) {
      console.error(
        "Erro ao buscar chamados em atendimento:",
        getApiErrorMessage(error, "Erro ao buscar chamados em atendimento."),
      );
      setChamadosEmAtendimento([]);
    }
  };

  const fetchFilaTecnicos = async (tecnico = tecnicoFiltroFila) => {
    try {
      const tecnicoNorm = normStr(tecnico);
      const params = compactObject({
        funcionario,
        tecnico:
          tecnicoNorm && tecnicoNorm.toUpperCase() !== "TODOS"
            ? tecnicoNorm
            : undefined,
        nivel: nivelUsuario,
        visao: isGerencial ? "GERENCIAL" : "OPERACIONAL",
      });

      const { data } = await api.get("/chamados/em-atendimento", { params });
      setChamadosFilaTecnicos((data.chamados || []).map(normalizeChamado));
      marcarAtualizado();
    } catch (error) {
      console.error(
        "Erro ao buscar fila dos técnicos:",
        getApiErrorMessage(error, "Erro ao buscar fila dos técnicos."),
      );
      setChamadosFilaTecnicos([]);
    }
  };

  const fetchTudo = async () => {
    await Promise.all([
      fetchChamadosPendentes(),
      fetchChamadosEmAtendimento(),
      fetchFilaTecnicos(tecnicoFiltroFila),
    ]);
  };

  const fetchTudoPorSetor = async (setorAlvo) => {
    await Promise.all([
      fetchChamadosPendentes(setorAlvo),
      fetchChamadosEmAtendimento(),
      fetchFilaTecnicos(tecnicoFiltroFila),
    ]);
  };

  const fetchDetalhesChamado = async (idChamado) => {
    try {
      const response = await api.get(`/chamados/detalhes/${idChamado}`);
      const det = response.data;

      let telefones = "";
      let razao = det?.chamado?.RazaoSocial || "";
      let fantasia = det?.chamado?.NomeFant || "";

      const abertoPor =
        det?.chamado?.AbertoPor || chamadoSelecionado?.Func || "";
      const dataAbertura =
        det?.chamado?.DataAbertura || det?.chamado?.data || "";
      const finalizadoPor = det?.chamado?.FinalizadoPor || "";
      const finalizadoPorCod = det?.chamado?.FinalizadoPorCod || "";
      const dataFinal = det?.chamado?.DataFinal || "";
      const horaFinal = det?.chamado?.HoraFinal || "";

      try {
        const codigo = det?.chamado?.chvCad || det?.chamado?.CodigoCad;
        if (codigo) {
          const cli = await api.get("/cliente/por-codigo", {
            params: { codigo },
          });

          const cd = cli?.data || {};
          telefones = cd?.telefones || cd?.Tel1 || cd?.Tel2 || telefones;
          razao = razao || cd?.RazaoSocial || cd?.razao || cd?.nome || "";
          fantasia =
            fantasia || cd?.NomeFant || cd?.NomeFantasia || cd?.fantasia || "";
        }
      } catch (_) {}

      setDetalhesChamado({
        ...det,
        chamado: {
          ...det.chamado,
          telefones,
          RazaoSocial: razao,
          NomeFant: fantasia,
          AbertoPor: abertoPor,
          DataAbertura: dataAbertura,
          FinalizadoPor: finalizadoPor,
          FinalizadoPorCod: finalizadoPorCod,
          DataFinal: dataFinal,
          HoraFinal: horaFinal,
        },
      });
    } catch (error) {
      console.error("Erro ao buscar detalhes do chamado:", error.message);
    }
  };

  const fetchTecnicos = useCallback(async () => {
    const normalizarNomes = (payload) =>
      (Array.isArray(payload) ? payload : [])
        .map((u) =>
          (u?.Nome ?? u?.nome ?? u?.RazaoSocial ?? u?.name ?? "")
            .toString()
            .trim(),
        )
        .filter(Boolean)
        .filter((n) => !textoIgual(n, funcionario))
        .filter((n, i, arr) => arr.indexOf(n) === i)
        .sort((a, b) => a.localeCompare(b, "pt-BR"));

    try {
      const { data } = await api.get("/func/setor/SUPORTE", {
        params: { situacao: "Ativo", bloqueado: 0 },
      });

      const nomes = normalizarNomes(data?.data || data);
      setTecnicosDisponiveis(nomes);
    } catch (errorFunc) {
      try {
        const { data } = await api.get("/loginUser");
        const nomes = normalizarNomes(data);
        setTecnicosDisponiveis(nomes);
      } catch (errorLoginUser) {
        console.error("Erro ao buscar técnicos:", errorFunc, errorLoginUser);
        setTecnicosDisponiveis([]);
      }
    }
  }, [funcionario]);

  const handleRedirecionarChamado = async (destino) => {
    if (isAcaoChamadoLoading) return;

    const idChamado = normStr(localStorage.getItem("idChamadoSelecionado"));
    const destinoNorm = normStr(destino);

    if (!idChamado || !destinoNorm) return;

    if (textoIgual(destinoNorm, chamadoSelecionado?.TecAtendimento)) {
      showError("Selecione um técnico diferente do atual.");
      return;
    }

    setIsAcaoChamadoLoading(true);

    try {
      await api.put(`/chamados/redirecionar/${idChamado}`, {
        novoTecnico: destinoNorm,
      });

      showInfo(`Chamado redirecionado para ${destinoNorm}`);
      await fetchTudo();
      setChamadoSelecionado(null);
      setTecnicoDestino("");
      localStorage.removeItem("idChamadoSelecionado");
    } catch (error) {
      console.error("Erro ao redirecionar chamado:", error);
      showError(getApiErrorMessage(error, "Erro ao redirecionar chamado."));
    } finally {
      setIsAcaoChamadoLoading(false);
    }
  };

  const handleRedirecionarSetor = async () => {
    if (isSubmittingSetor) return;

    const idChamado = normStr(
      localStorage.getItem("idChamadoSelecionado") || chamadoSelecionado?.id,
    );
    const setorDestino = normSetor(setorDestinoChamado);

    if (!idChamado || !setorDestinoChamado) {
      showError("Selecione o setor de destino.");
      return;
    }

    if (!podeMoverSetor) {
      showError("Seu perfil não possui permissão para alterar o setor.");
      return;
    }

    if (setorDestino === normSetor(chamadoSelecionado?.Setor)) {
      showError("O chamado já está neste setor.");
      return;
    }

    setIsSubmittingSetor(true);

    try {
      const { data } = await api.put(
        `/chamados/redirecionar-setor/${idChamado}`,
        {
          setorDestino,
          funcionario,
          nivel: nivelUsuario,
          setorUsuario,
          descricao: `Chamado encaminhado do setor ${
            chamadoSelecionado?.setorNorm || setorFiltro
          } para ${setorDestino}.`,
        },
      );

      showInfo(data?.message || `Chamado encaminhado para ${setorDestino}.`);
      setSetorDestinoChamado("");
      setChamadoSelecionado(null);
      setDetalhesChamado(null);
      localStorage.removeItem("idChamadoSelecionado");
      await fetchTudo();
    } catch (error) {
      console.error("Erro ao redirecionar setor:", error);
      showError(
        getApiErrorMessage(error, "Erro ao redirecionar o setor do chamado."),
      );
    } finally {
      setIsSubmittingSetor(false);
    }
  };

  const handleLiberarChamado = async () => {
    if (isAcaoChamadoLoading) return;

    const idChamado = normStr(localStorage.getItem("idChamadoSelecionado"));
    if (!idChamado || !funcionario) return;

    setIsAcaoChamadoLoading(true);

    try {
      await api.put(`/chamados/liberar/${idChamado}`, { funcionario });
      showInfo("Chamado liberado com sucesso.");
      await fetchTudo();
      setChamadoSelecionado(null);
      setTecnicoDestino("");
      localStorage.removeItem("idChamadoSelecionado");
    } catch (error) {
      console.error("Erro ao liberar chamado:", error);
      showError(getApiErrorMessage(error, "Erro ao liberar chamado."));
    } finally {
      setIsAcaoChamadoLoading(false);
    }
  };

  const handlePegarChamado = async (idParam = null) => {
    if (isAcaoChamadoLoading) return;

    if (!canTakeFromCurrentQueue) {
      showError(
        `Ação negada. Esta fila é do setor ${normSetor(
          setorFiltro,
        )} e seu setor é ${setorUsuario}.`,
      );
      return;
    }

    const idChamado = normStr(idParam || localStorage.getItem("idChamadoSelecionado"));
    if (!idChamado || !funcionario) return;

    setIsAcaoChamadoLoading(true);

    try {
      const response = await api.put(`/chamados/${idChamado}`, { funcionario });

      if (response.data?.sucesso) {
        await fetchTudo();
        setChamadoSelecionado(null);
        localStorage.removeItem("idChamadoSelecionado");
        showInfo("Chamado assumido com sucesso.");
        return;
      }

      showError(response.data?.mensagem || "Não foi possível assumir o chamado.");
    } catch (error) {
      console.error("Erro ao pegar chamado:", error);
      showError(getApiErrorMessage(error, "Erro ao pegar chamado."));
    } finally {
      setIsAcaoChamadoLoading(false);
    }
  };

  useEffect(() => {
    if (
      (abaAtiva === "atendendo" || abaAtiva === "filaTecnicos") &&
      chamadoSelecionado
    ) {
      fetchTecnicos();
      setTecnicoDestino("");
    }
  }, [abaAtiva, chamadoSelecionado, fetchTecnicos]);

  const handleAbrirDescricao = () => setDescricaoModalAberto(true);

  const handleSalvarDescricao = async () => {
    if (isSubmittingDescricao) return;

    const idChamado = localStorage.getItem("idChamadoSelecionado");
    if (!novaDescricao.trim() || !idChamado) return;

    setIsSubmittingDescricao(true);

    try {
      await api.post("/chamados/descricao", {
        idChamado,
        descricao: novaDescricao,
      });

      await fetchDetalhesChamado(idChamado);
      setNovaDescricao("");
      setDescricaoModalAberto(false);
      showInfo("Descrição incluída com sucesso.");
    } catch (error) {
      console.error("Erro ao incluir descrição:", error.message);
      showError("Erro ao incluir descrição.");
    } finally {
      setIsSubmittingDescricao(false);
    }
  };

  const handleAbrirHistorico = (codigo) => {
    setCodigoHistoricoCliente(codigo);
    setModalHistoricoAberto(true);
  };

  const handleAbrirCadastroCliente = () => {
    const codigo = normStr(clienteSelecionado?.CodigoCad);

    if (!codigo) {
      showError("Selecione um cliente antes de abrir o cadastro.");
      return;
    }

    const url = `${ROTA_CADASTRO_CLIENTE}?codigo=${encodeURIComponent(codigo)}`;
    window.location.assign(url);
  };

  const buscarChamadosAbertosClienteApi = async (codigo) => {
    const endpoints = [
      `/chamados/cliente/${codigo}/existe-aberto`,
      `/ssw/chamados/cliente/${codigo}/existe-aberto`,
    ];

    let ultimoErro = null;

    for (const endpoint of endpoints) {
      try {
        const { data } = await api.get(endpoint);

        return {
          existe: Boolean(data?.existe),
          chamados: Array.isArray(data?.chamados) ? data.chamados : [],
        };
      } catch (err) {
        ultimoErro = err;
      }
    }

    throw ultimoErro;
  };

  const buscarPendenciasFinanceirasClienteApi = async (codigo) => {
    const { data } = await api.get("/cliente/parcelas", {
      params: { codigo },
    });

    const resumo = getResumoPendenciasFinanceiras(data?.parcelas);

    return {
      dados: data,
      ...resumo,
    };
  };

  const abrirModalNovoChamado = async () => {
    const codigo = normStr(clienteSelecionado?.CodigoCad);

    if (!codigo) {
      setModalNovoChamadoAberto(true);
      return;
    }

    let resultadoChamados = { existe: false, chamados: [] };
    let resultadoFinanceiro = {
      dados: parcelasCliente,
      ...getResumoPendenciasFinanceiras(parcelasCliente?.parcelas),
    };
    const [validacaoChamados, validacaoFinanceiro] = await Promise.allSettled([
      buscarChamadosAbertosClienteApi(codigo),
      buscarPendenciasFinanceirasClienteApi(codigo),
    ]);

    const falhouValidacaoChamados = validacaoChamados.status === "rejected";

    if (validacaoChamados.status === "fulfilled") {
      resultadoChamados = validacaoChamados.value;
    } else {
      console.error(
        "Erro ao validar chamados abertos:",
        validacaoChamados.reason,
      );
    }

    if (validacaoFinanceiro.status === "fulfilled") {
      resultadoFinanceiro = validacaoFinanceiro.value;
      setParcelasCliente(resultadoFinanceiro.dados);
      setQtdParcelasAtrasadas(resultadoFinanceiro.atrasadas);
    } else {
      console.error(
        "Erro ao validar parcelas do cliente:",
        validacaoFinanceiro.reason,
      );
    }

    const possuiChamadoAberto = Boolean(resultadoChamados?.existe);
    const possuiPendenciaFinanceira =
      Number(resultadoFinanceiro?.atrasadas || 0) > 0;

    if (possuiChamadoAberto || possuiPendenciaFinanceira) {
      setConfirmacaoNovoChamado({
        cliente: clienteSelecionado,
        chamados: resultadoChamados?.chamados || [],
        qtdParcelasAtrasadas: Number(resultadoFinanceiro?.atrasadas || 0),
        qtdParcelasEmAberto: Number(resultadoFinanceiro?.emAberto || 0),
      });
      return;
    }

    if (falhouValidacaoChamados) {
      showInfo(
        "Não foi possível validar chamados abertos. O cadastro do novo chamado continuará normalmente.",
      );
    }

    setModalNovoChamadoAberto(true);
  };

  const confirmarAberturaNovoChamado = () => {
    setConfirmacaoNovoChamado(null);
    setModalNovoChamadoAberto(true);
  };

  const cancelarAberturaNovoChamado = () => {
    setConfirmacaoNovoChamado(null);
  };

  const handleVerificarDescricoes = async (chamado) => {
    if (!chamado?.id) return;

    setChamadoSelecionado(chamado);
    setIsIntervindo(false);
    setSetorDestinoChamado("");
    localStorage.setItem("idChamadoSelecionado", chamado.id);
    await fetchDetalhesChamado(chamado.id);
  };

  const handleFinalizarChamado = async () => {
    if (!detalhesChamado.historico || detalhesChamado.historico.length === 0) {
      showError(
        "Não é possível finalizar o chamado sem ao menos uma descrição.",
      );
      return;
    }

    if (isSubmittingFinalizar) return;

    const idChamado = normStr(localStorage.getItem("idChamadoSelecionado"));
    const funcionarioNome = getSessionValue("RazaoSocial", "Funcionario", "funcionario");
    const codFunc = getSessionValue("codFunc", "CodFunc", "CODFUNC");

    if (!idChamado || !funcionarioNome || !codFunc) {
      showError("Sessão inválida. Faça login novamente antes de finalizar.");
      return;
    }

    setIsSubmittingFinalizar(true);

    try {
      const response = await api.put(
        `/chamados/finalizar/${idChamado}`,
        compactObject({
          funcionario: funcionarioNome,
          codFunc,
        }),
      );

      if (response.status === 200) {
        showInfo(
          response.data?.redirecionado
            ? response.data.mensagem
            : "Chamado finalizado com sucesso!",
        );

        await fetchTudo();
        setChamadoSelecionado(null);
        localStorage.removeItem("idChamadoSelecionado");
      }
    } catch (error) {
      if (error.response?.status === 403) {
        showError(error.response.data.message);
      } else {
        console.error("Erro ao finalizar chamado:", error);
        showError(getApiErrorMessage(error, "Erro ao finalizar chamado."));
      }
    } finally {
      setIsSubmittingFinalizar(false);
    }
  };

  const handleAbrirIntervencao = () => {
    setIsIntervindo(true);
    setAcaoIntervencao("ASSUMIR");
    setTecnicoDestinoAdm("");
    setDescricaoIntervencao("");
  };

  const handleConfirmarIntervencao = async () => {
    if (isSubmittingIntervencao) return;

    const idChamado = normStr(localStorage.getItem("idChamadoSelecionado"));
    if (!idChamado) return;

    const funcionarioAdm = getSessionValue("RazaoSocial", "Funcionario", "funcionario");
    const codFuncAdm = getSessionValue("codFunc", "CodFunc", "CODFUNC");

    if (!funcionarioAdm || !codFuncAdm) {
      showError("Sessão inválida. Faça login novamente antes de intervir.");
      return;
    }

    if (!descricaoIntervencao.trim()) {
      showError("Informe a descrição da intervenção.");
      return;
    }

    if (acaoIntervencao === "REDIRECIONAR" && !tecnicoDestinoAdm) {
      showError("Selecione o técnico de destino.");
      return;
    }

    setIsSubmittingIntervencao(true);

    try {
      const payload = compactObject({
        funcionarioAdm,
        codFuncAdm,
        nivelAdm: nivelUsuario,
        acao: acaoIntervencao,
        tecnicoDestino:
          acaoIntervencao === "REDIRECIONAR"
            ? normStr(tecnicoDestinoAdm)
            : undefined,
        descricaoIntervencao: normStr(descricaoIntervencao),
      });

      const resp = await api.put(`/chamados/intervir/${idChamado}`, payload);

      showInfo(
        resp?.data?.detalhe ||
          resp?.data?.mensagem ||
          "Intervenção aplicada com sucesso.",
      );

      await fetchTudo();

      setChamadoSelecionado(null);
      setIsIntervindo(false);
      localStorage.removeItem("idChamadoSelecionado");
    } catch (error) {
      if (error.response?.status === 403) {
        showError(error.response.data.message);
      } else {
        console.error("Erro ao intervir no chamado:", error);
        showError(getApiErrorMessage(error, "Erro ao intervir no chamado."));
      }
    } finally {
      setIsSubmittingIntervencao(false);
    }
  };

  useEffect(() => {
    return () => {
      localStorage.removeItem("idChamadoSelecionado");
    };
  }, []);

  const clienteFetchSeq = useRef(0);
  const clienteAbort = useRef(null);

  const clearCliente = () => {
    if (clienteAbort.current) clienteAbort.current.abort();

    setClienteOption(null);
    setClienteSelecionado(null);
    setParcelasCliente({
      parcelas: [],
      totalGeral: "0,00",
      totalAtrasado: "0,00",
    });
    setPlanosCliente([]);
    setQtdParcelasAtrasadas(0);
  };

  const handleSelectCliente = (opt) => {
    if (!opt) {
      clearCliente();
      return;
    }

    if (clienteAbort.current) clienteAbort.current.abort();

    setParcelasCliente({
      parcelas: [],
      totalGeral: "0,00",
      totalAtrasado: "0,00",
    });
    setPlanosCliente([]);
    setQtdParcelasAtrasadas(0);
    setClienteOption(opt);

    const raw = opt?.data ?? opt;
    const norm = normalizeCliente(raw);

    const codigo =
      normStr(norm.CodigoCad) ||
      normStr(opt?.value) ||
      normStr(raw?.value) ||
      normStr(raw?.codigo) ||
      normStr(raw?.chvCad);

    setClienteSelecionado({ ...norm, CodigoCad: codigo });
  };

  useEffect(() => {
    const codigo = clienteSelecionado?.CodigoCad;
    if (!codigo) return;

    const seq = ++clienteFetchSeq.current;

    if (clienteAbort.current) clienteAbort.current.abort();

    const ac = new AbortController();
    clienteAbort.current = ac;

    const applyIfLatest = (fn) => {
      if (ac.signal.aborted) return false;
      if (seq !== clienteFetchSeq.current) return false;
      fn();
      return true;
    };

    (async () => {
      try {
        const base = await api.get("/cliente/por-codigo", {
          params: { codigo },
          signal: ac.signal,
        });

        applyIfLatest(() => {
          setClienteSelecionado((prev) =>
            normalizeCliente({ ...(prev || {}), ...(base?.data || {}) }),
          );
        });

        const parcelasRes = await api.get("/cliente/parcelas", {
          params: { codigo },
          signal: ac.signal,
        });

        applyIfLatest(() => {
          const resumoFinanceiro = getResumoPendenciasFinanceiras(
            parcelasRes.data?.parcelas,
          );

          setParcelasCliente(parcelasRes.data);
          setQtdParcelasAtrasadas(resumoFinanceiro.atrasadas);
        });

        const planosRes = await api.get("/cliente/planos", {
          params: { codigo },
          signal: ac.signal,
        });

        applyIfLatest(() => setPlanosCliente(planosRes.data));
      } catch (error) {
        if (error?.name === "CanceledError" || error?.code === "ERR_CANCELED") {
          return;
        }

        console.error(
          "Erro ao buscar dados do cliente:",
          error?.message || error,
        );
      }
    })();

    return () => ac.abort();
  }, [clienteSelecionado?.CodigoCad]);

  useEffect(() => {
    fetchTudo();
    fetchTecnicos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (abaAtiva === "pendentes") {
      fetchChamadosPendentes();
    } else if (abaAtiva === "atendendo") {
      fetchChamadosEmAtendimento();
    } else if (abaAtiva === "filaTecnicos") {
      fetchFilaTecnicos(tecnicoFiltroFila);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [abaAtiva, tecnicoFiltroFila]);

  useEffect(() => {
    if (abaAtiva === "pendentes") {
      fetchChamadosPendentes();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setorFiltro]);

  useEffect(() => {
    setCardsAbertosMobile(new Set());
  }, [abaAtiva, setorFiltro, tecnicoFiltroFila, filtroRapido, termoBusca]);

 const normServidor = useCallback(
  (v) =>
    String(v || "")
      .trim()
      .toLowerCase(),
  [],
);

const labelServidorFull = useCallback(
  (v) => {
    const n = normServidor(v);

    if (n === "spw") return "SPW";
    if (n === "web") return "Sistema Web";
    if (n === "local") return "Sistema Local";

    return v || "-";
  },
  [normServidor],
);

  const labelServidorShort = (v) => {
    const n = normServidor(v);
    if (n === "spw") return "SPW";
    if (n === "web") return "WEB";
    if (n === "local") return "LOCAL";
    return "-";
  };

  const classServidor = (v) => {
    const n = normServidor(v);
    if (n === "spw") return "badge badge-spw";
    if (n === "web") return "badge badge-web";
    if (n === "local") return "badge badge-local";
    return "badge";
  };

  const ServidorBadge = ({ value }) => (
    <span className={classServidor(value)} title={labelServidorFull(value)}>
      {labelServidorShort(value)}
    </span>
  );

  const safeStr = (v) => String(v ?? "").toLowerCase();

  const chamadosBase = useMemo(() => {
    if (abaAtiva === "pendentes") return chamadosPendentes;
    if (abaAtiva === "atendendo") return chamadosEmAtendimento;
    return chamadosFilaTecnicos;
  }, [
    abaAtiva,
    chamadosPendentes,
    chamadosEmAtendimento,
    chamadosFilaTecnicos,
  ]);

  const chamadosEnriquecidos = useMemo(() => {
    return chamadosBase.map((chamado) => {
      const sla = getSlaInfo(chamado);
      return {
        ...chamado,
        sla,
        slaScore: sla.score,
      };
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chamadosBase, agoraTick, abaAtiva]);

  const kpis = useMemo(() => {
    const pendentesCriticos = chamadosPendentes.filter((c) => {
      const sla = getSlaInfo(c);
      return sla.status === "critico" || sla.minutos >= 60;
    }).length;

    const semDono = chamadosPendentes.filter(
      (c) => !normStr(c.TecAtendimento),
    ).length;

    const mais30 = chamadosPendentes.filter((c) => {
      const sla = getSlaInfo(c);
      return sla.minutos >= 30;
    }).length;

    return {
      pendentes: chamadosPendentes.length,
      atendimento: chamadosEmAtendimento.length,
      filaTecnicos: chamadosFilaTecnicos.length,
      criticos: pendentesCriticos,
      semDono,
      mais30,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    chamadosPendentes,
    chamadosEmAtendimento,
    chamadosFilaTecnicos,
    agoraTick,
  ]);

  const tecnicoStats = useMemo(() => {
    const mapa = new Map();

    chamadosFilaTecnicos.forEach((c) => {
      const nome = normStr(c.TecAtendimento) || "Sem técnico";
      mapa.set(nome, (mapa.get(nome) || 0) + 1);
    });

    return Array.from(mapa.entries())
      .map(([nome, total]) => ({ nome, total }))
      .sort((a, b) => b.total - a.total)
      .slice(0, 6);
  }, [chamadosFilaTecnicos]);

  const compareBy = useCallback((a, b, key) => {
    switch (key) {
      case "urgencia":
        return (Number(a.urgencia) || 0) - (Number(b.urgencia) || 0);
      case "ChvCad":
        return (Number(a.ChvCad) || 0) - (Number(b.ChvCad) || 0);
      case "Data":
        return (
          parseDateHoraBR(a.Data, a.Hora || a.hora) -
          parseDateHoraBR(b.Data, b.Hora || b.hora)
        );
      case "slaScore":
        return (Number(a.slaScore) || 0) - (Number(b.slaScore) || 0);
      case "ServidorWeb":
        return safeStr(labelServidorFull(a.ServidorWeb)).localeCompare(
          safeStr(labelServidorFull(b.ServidorWeb)),
        );
      case "Setor":
        return safeStr(a.setorNorm).localeCompare(safeStr(b.setorNorm));
      default:
        return safeStr(a[key]).localeCompare(safeStr(b[key]));
    }
  }, [labelServidorFull]);

  const requestSort = (key) =>
    setSortConfig((prev) =>
      prev.key === key
        ? { key, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { key, direction: key === "slaScore" ? "desc" : "asc" },
    );

  const trocarFiltroRapido = (value) => {
    setFiltroRapido(value);

    if (value === "PENDENTES") setAbaAtiva("pendentes");
    if (value === "EM_ATENDIMENTO") setAbaAtiva("atendendo");
    if (value === "CRITICOS" || value === "SEM_DONO" || value === "MAIS_30") {
      setAbaAtiva("pendentes");
      setSortConfig({ key: "slaScore", direction: "desc" });
    }
  };

  const chamadosFiltrados = useMemo(() => {
    const termo = termoBusca.trim().toLowerCase();

    return chamadosEnriquecidos.filter((c) => {
      const servidor = normServidor(c.ServidorWeb);
      const sla = c.sla || getSlaInfo(c);

      if (filtroRapido === "SEM_DONO" && !sla.semDono) return false;
      if (filtroRapido === "CRITICOS" && sla.status !== "critico") return false;
      if (filtroRapido === "MAIS_30" && sla.minutos < 30) return false;
      if (filtroRapido === "WEB" && servidor !== "web") return false;
      if (filtroRapido === "LOCAL" && servidor !== "local") return false;
      if (filtroRapido === "SPW" && servidor !== "spw") return false;

      if (!termo) return true;

      const alvo = [
        c.ChvCad,
        c.CodigoCad,
        c.RazaoSocial,
        c.NomeFant,
        c.Func,
        c.TecAtendimento,
        c.DescrAtend,
        c.setorNorm,
        c.Data,
        c.Hora,
        c.hora,
        c.ServidorWeb,
      ]
        .join(" ")
        .toLowerCase();

      return alvo.includes(termo);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chamadosEnriquecidos, filtroRapido, termoBusca]);

  const sortedChamados = useMemo(() => {
    const arr = [...chamadosFiltrados];

    if (!sortConfig.key) return arr;

    arr.sort((a, b) => compareBy(a, b, sortConfig.key));

    if (sortConfig.direction === "desc") arr.reverse();

    return arr;
  }, [chamadosFiltrados, sortConfig, compareBy]);

  const formatUltimaAtualizacao = () => {
    if (!ultimaAtualizacao) return "Ainda não atualizado";
    return ultimaAtualizacao.toLocaleTimeString("pt-BR", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const renderSortCaret = (key) => (
    <span className="sort-caret">
      {sortConfig.key === key
        ? sortConfig.direction === "asc"
          ? "▲"
          : "▼"
        : "↕"}
    </span>
  );

  const renderClienteStatus = () => {
    const tipCad = clienteSelecionado?.TipCad || "—";
    const isDesistente = tipCad.toLowerCase() === "cliente desistente";

    return (
      <span
        className={`cliente-status-badge ${
          isDesistente ? "status-desistente" : "status-ativo"
        }`}
      >
        {tipCad}
      </span>
    );
  };

  const getLicencaChamado = (chamado) =>
    normStr(chamado?.ChvCad) || normStr(chamado?.CodigoCad) || "—";

  const getFantasiaChamado = (chamado) =>
    normStr(chamado?.NomeFant) ||
    normStr(chamado?.NomeFantasia) ||
    normStr(chamado?.Fantasia) ||
    normStr(chamado?.RazaoSocial) ||
    "Sem fantasia";

  const getRazaoChamado = (chamado) =>
    normStr(chamado?.RazaoSocial) ||
    normStr(chamado?.Cliente) ||
    normStr(chamado?.NomeFant) ||
    "—";

  const getAberturaChamado = (chamado) => {
    const data = normStr(chamado?.Data);
    const hora = normStr(chamado?.Hora || chamado?.hora);

    if (!data && !hora) return "—";
    if (!hora) return data;

    return `${data} às ${hora}`;
  };

  const totalColunasTabela = showAtendente ? 8 : 7;

  const renderChamadoMobileCard = (chamado) => {
    const id = chamado.id ?? `${chamado.ChvCad}-${chamado.Data}-${chamado.Hora || chamado.hora || ""}`;
    const idKey = String(id ?? "");
    const urgencia = Number(chamado.urgencia) || 0;
    const sla = chamado.sla || getSlaInfo(chamado);
    const aberto = cardsAbertosMobile.has(idKey);
    const tecnico = normStr(chamado.TecAtendimento) || "Sem dono";

    return (
      <article
        key={idKey}
        className={`ticket-mobile-card urg-${urgencia} sla-${sla.status} ${
          aberto ? "is-open" : "is-collapsed"
        }`}
      >
        <div className={`ticket-mobile-priority-bar urg-${urgencia}`} />

        <div className="ticket-mobile-head">
          <button
            type="button"
            className="ticket-mobile-title-button"
            onClick={() => toggleMobileCard(idKey)}
            aria-expanded={aberto}
            aria-label={aberto ? "Recolher chamado" : "Expandir chamado"}
          >
            <span className="cliente-licenca">
              Licença: {getLicencaChamado(chamado)}
            </span>
            {isRetornoProjeto(chamado) && (
              <span className="badge-retorno-projeto">
                Retorno do projeto #{getProjetoOrigemChamado(chamado)}
              </span>
            )}
            <strong>{getFantasiaChamado(chamado)}</strong>
            <small>{getRazaoChamado(chamado)}</small>
          </button>

          <div className={`sla-badge sla-${sla.status}`}>
            <strong>{sla.tempo}</strong>
            <span>{sla.label}</span>
          </div>

          <button
            type="button"
            className="ticket-mobile-toggle"
            onClick={() => toggleMobileCard(idKey)}
            aria-expanded={aberto}
            title={aberto ? "Recolher" : "Expandir"}
          >
            {aberto ? "−" : "+"}
          </button>
        </div>

        <div className="ticket-mobile-tags">
          <span className="urg-cell">
            <span className={`urg-dot urg-${urgencia}`} />
            {URG_LABEL[urgencia] || "—"}
          </span>

          <span className="ticket-mobile-tag">
            <ServidorBadge value={chamado.ServidorWeb} />
          </span>

          <span className="ticket-mobile-tag">
            Setor: {chamado.setorNorm || "SUPORTE"}
          </span>
        </div>

        <div className="ticket-mobile-summary-grid">
          {showAtendente && (
            <div>
              <span>Técnico</span>
              <strong>{tecnico}</strong>
            </div>
          )}

          {abaAtiva === "pendentes" && sla.semDono && (
            <div className={`summary-alert sla-${sla.status}`}>
              <span>Situação</span>
              <strong>Sem responsável há {sla.tempo}</strong>
            </div>
          )}
        </div>

        {aberto && (
          <div className="ticket-mobile-body">
            <div className="ticket-mobile-grid">
              {showAtendente && (
                <div>
                  <span>Técnico</span>
                  <strong>{tecnico}</strong>
                </div>
              )}

              <div>
                <span>Aberto por</span>
                <strong>{chamado.Func || "—"}</strong>
              </div>

              <div>
                <span>Abertura</span>
                <strong>{getAberturaChamado(chamado)}</strong>
              </div>
            </div>

            <div className="ticket-mobile-desc">
              <span>Descrição principal</span>
              <p>{chamado.DescrAtend || "—"}</p>
            </div>

            {abaAtiva === "pendentes" && sla.semDono && (
              <div className={`sem-dono-alert sla-${sla.status}`}>
                Chamado sem responsável há {sla.tempo}.
              </div>
            )}

            <div className="ticket-mobile-actions">
              {abaAtiva === "pendentes" && (
                <button
                  type="button"
                  className="btn btn-pegar-row"
                  disabled={!canTakeFromCurrentQueue || isAcaoChamadoLoading}
                  onClick={() => {
                    if (!canTakeFromCurrentQueue) return;
                    localStorage.setItem("idChamadoSelecionado", chamado.id);
                    handlePegarChamado(chamado.id);
                  }}
                >
                  Pegar
                </button>
              )}

              <button
                type="button"
                className="btn btn-icon-row"
                onClick={() => handleVerificarDescricoes(chamado)}
              >
                Ver descrições
              </button>

              <button
                type="button"
                className="btn btn-icon-row"
                onClick={() => handleAbrirHistorico(chamado.ChvCad || chamado.CodigoCad)}
              >
                Histórico
              </button>
            </div>
          </div>
        )}
      </article>
    );
  };

  return (
    <MainLayout>
      <main
        className={`chamados-page chamados-container chamados-modern chamados-prod ${
          descSempreVisivel ? "desc-always-open" : "desc-collapsible"
        }`}
      >
        <section className="chamados-topbar chamados-topbar-safe">
          <div className="topbar-title">
            <h1>Chamados</h1>
            <span>
              Atualizado às <strong>{formatUltimaAtualizacao()}</strong>
            </span>
          </div>
        </section>

        <section
          className="chamados-toolbar chamados-toolbar-safe-zone"
          aria-label="Ações rápidas dos chamados"
        >
          <div className="toolbar-copy">
            <strong>Central de atendimento</strong>
            <span>Gestão operacional de filas, SLA e atendimento técnico.</span>
          </div>

          <div className="topbar-actions">
            <button
              type="button"
              className="btn btn-refresh"
              onClick={fetchTudo}
              title="Atualizar filas"
            >
              Atualizar
            </button>

            <button
              type="button"
              className="btn chamados-add-button"
              onClick={abrirModalNovoChamado}
            >
              + Novo chamado
            </button>
          </div>
        </section>

        <section className="cliente-panel cliente-panel-first">
          <div className="cliente-panel-top">
            <div>
              <h2>Consulta rápida do cliente</h2>
              <p>
                Busque o cliente antes de abrir, consultar ou validar chamados.
              </p>
            </div>
          </div>

          <div className="busca-cliente-linha">
            <SelectCliente
              className="select-cliente"
              value={clienteOption}
              onChange={handleSelectCliente}
              includeInactiveSearch={false}
              isClearable
            />
          </div>

          {clienteSelecionado && (
            <div className="dados-cliente dados-cliente-produtivo">
              <div className="dados-cliente-header">
                <div>
                  <h3>{clienteSelecionado.RazaoSocial || "Cliente"}</h3>
                  <span>{clienteSelecionado.NomeFant || "Sem fantasia"}</span>
                </div>

                <button
                  className="btn-fechar-cliente"
                  onClick={clearCliente}
                  title="Fechar dados do cliente"
                >
                  ×
                </button>
              </div>

              <div className="cliente-resumo-grid">
                <div className="cliente-resumo-card">
                  <span>Status</span>
                  {renderClienteStatus()}
                </div>

                <div className="cliente-resumo-card">
                  <span>Liberação</span>
                  <strong>
                    {clienteSelecionado.BLQ === "L"
                      ? "Liberado"
                      : clienteSelecionado.BLQ === "N"
                        ? "Normal"
                        : clienteSelecionado.BLQ === "B"
                          ? "Bloqueado"
                          : clienteSelecionado.BLQ === "G"
                            ? "Negociação"
                            : clienteSelecionado.BLQ === "P"
                              ? "Piloto"
                              : "Desconhecido"}
                  </strong>
                </div>

                <div className="cliente-resumo-card">
                  <span>Sistema</span>
                  <strong>
                    {labelServidorFull(clienteSelecionado.ServidorWeb)}
                  </strong>
                </div>

                <div
                  className={`cliente-resumo-card ${
                    qtdParcelasAtrasadas >= 2
                      ? "danger"
                      : qtdParcelasAtrasadas === 1
                        ? "warning"
                        : ""
                  }`}
                >
                  <span>Parcelas atrasadas</span>
                  <strong>{qtdParcelasAtrasadas}</strong>
                </div>
              </div>

              {qtdParcelasAtrasadas > 0 && (
                <div
                  className={`cliente-alerta-operacional ${
                    qtdParcelasAtrasadas >= 2 ? "critico" : "atencao"
                  }`}
                  role="status"
                >
                  <div className="cliente-alerta-operacional-copy">
                    <span className="cliente-alerta-operacional-icon" aria-hidden="true">
                      !
                    </span>
                    <div>
                      <strong>
                        Financeiro: {qtdParcelasAtrasadas}{" "}
                        {qtdParcelasAtrasadas === 1
                          ? "parcela atrasada"
                          : "parcelas atrasadas"}
                      </strong>
                      <p>
                        O atendimento pode continuar, mas o suporte deve visualizar
                        a pendência financeira antes de abrir um novo chamado.
                      </p>
                    </div>
                  </div>

                  <button
                    type="button"
                    className="btn btn-sm cliente-alerta-operacional-acao"
                    onClick={() => setMostrarModalParcelas(true)}
                  >
                    Ver parcelas
                  </button>
                </div>
              )}

              <div className="grid-dados-cliente">
                <div>
                  <strong>Chave:</strong> {clienteSelecionado.CodigoCad || "—"}
                </div>
                <div>
                  <strong>CNPJ:</strong> {clienteSelecionado.CpfCnpj || "—"}
                </div>
                <div>
                  <strong>Telefones:</strong>{" "}
                  {clienteSelecionado.telefones || "—"}
                </div>
                <div>
                  <strong>Máquinas:</strong>{" "}
                  {clienteSelecionado.NumMaquina || "—"}
                </div>
                <div>
                  <strong>Nº Autorização:</strong>{" "}
                  {clienteSelecionado.NAutoriza?.trim() !== ""
                    ? clienteSelecionado.NAutoriza
                    : "Não informado"}
                </div>
                <div>
                  <strong>Tipo:</strong> {clienteSelecionado.Comercio || "—"}
                </div>
                <div>
                  <strong>Endereço:</strong>{" "}
                  {clienteSelecionado.enderecoLinha1 || "—"}
                </div>
                <div>{clienteSelecionado.enderecoLinha2 || "—"}</div>
                <div>
                  <strong>Observações:</strong>{" "}
                  <span className="dc-value dc-multiline">
                    {clienteSelecionado.Obs || "—"}
                  </span>
                </div>
                <div>
                  <strong>Restrições:</strong>{" "}
                  <span className="dc-value dc-multiline">
                    {clienteSelecionado.Restricao || "—"}
                  </span>
                </div>
              </div>

              <div className="btns-financeiro-cliente">
                <button
                  className="btn btn-sm"
                  onClick={() => setMostrarModalParcelas(true)}
                >
                  Parcelas
                </button>

                <button
                  className="btn btn-sm"
                  onClick={() => setMostrarModalPlanos(true)}
                >
                  Planos
                </button>

                <button
                  className="btn btn-sm"
                  onClick={() => setmostrarModalNumeroSerie(true)}
                  disabled={
                    clienteSelecionado?.TipCad?.toLowerCase() !==
                    "cliente de software"
                  }
                  title={
                    clienteSelecionado?.TipCad?.toLowerCase() !==
                    "cliente de software"
                      ? "Somente disponível para Cliente de Software"
                      : ""
                  }
                >
                  Nº Série
                </button>

                <button
                  className="btn btn-sm"
                  onClick={() => setMostrarModalTolerancia(true)}
                >
                  Tolerância
                </button>

                <button
                  className="btn btn-sm btn-abrir-cadastro"
                  onClick={handleAbrirCadastroCliente}
                  disabled={!clienteSelecionado?.CodigoCad}
                >
                  Cadastro
                </button>

                <button
                  className="btn btn-sm"
                  onClick={() =>
                    handleAbrirHistorico(clienteSelecionado.CodigoCad)
                  }
                >
                  Histórico
                </button>
              </div>
            </div>
          )}
        </section>

        <section className="collapsible-section kpi-collapse">
          <button
            type="button"
            className="collapse-header"
            onClick={() => setKpisAbertos((v) => !v)}
          >
            <span>Indicadores da operação</span>
            <small>
              {kpis.pendentes} pendentes · {kpis.criticos} críticos
            </small>
            <b>{kpisAbertos ? "−" : "+"}</b>
          </button>

          {kpisAbertos && (
            <div className="kpi-grid chamados-kpis">
              <article className="kpi-card kpi-pendentes">
                <span>Pendentes</span>
                <strong>{kpis.pendentes}</strong>
                <small>{setorFiltro}</small>
              </article>

              <article className="kpi-card kpi-atendimento">
                <span>Em atendimento</span>
                <strong>{kpis.atendimento}</strong>
                <small>meus chamados</small>
              </article>

              <article className="kpi-card kpi-criticos">
                <span>Críticos</span>
                <strong>{kpis.criticos}</strong>
                <small>SLA / urgência</small>
              </article>

              <article className="kpi-card kpi-sem-dono">
                <span>Sem dono</span>
                <strong>{kpis.semDono}</strong>
                <small>aguardando técnico</small>
              </article>

              <article className="kpi-card kpi-tempo">
                <span>+30 min</span>
                <strong>{kpis.mais30}</strong>
                <small>em aberto</small>
              </article>

              <article className="kpi-card kpi-fila">
                <span>Fila técnicos</span>
                <strong>{kpis.filaTecnicos}</strong>
                <small>distribuídos</small>
              </article>
            </div>
          )}
        </section>

        <section className="tabs-prod">
          <button
            type="button"
            className={`tab-prod ${abaAtiva === "pendentes" ? "active" : ""}`}
            onClick={() => setAbaAtiva("pendentes")}
          >
            Pendentes
            <strong>{chamadosPendentes.length}</strong>
          </button>

          <button
            type="button"
            className={`tab-prod ${abaAtiva === "atendendo" ? "active" : ""}`}
            onClick={() => setAbaAtiva("atendendo")}
          >
            Em atendimento
            <strong>{chamadosEmAtendimento.length}</strong>
          </button>

          <button
            type="button"
            className={`tab-prod ${
              abaAtiva === "filaTecnicos" ? "active" : ""
            }`}
            onClick={() => setAbaAtiva("filaTecnicos")}
          >
            Fila dos técnicos
            <strong>{chamadosFilaTecnicos.length}</strong>
          </button>
        </section>

        <section className="filtros-rapidos filtros-prod">
          {FILTROS_RAPIDOS.map((filtro) => (
            <button
              key={filtro.value}
              type="button"
              className={`pill-filter ${
                filtroRapido === filtro.value ? "active" : ""
              }`}
              onClick={() => trocarFiltroRapido(filtro.value)}
            >
              {filtro.label}
            </button>
          ))}

          <button
            type="button"
            className={`pill-filter filter-toggle ${
              filtrosAbertos ? "active" : ""
            }`}
            onClick={() => setFiltrosAbertos((v) => !v)}
          >
            {filtrosAbertos ? "Ocultar filtros" : "Filtros"}
          </button>
        </section>

        {filtrosAbertos && (
          <section className="painel-controles painel-controles-prod">
            <div className="setor-filter">
              <label htmlFor="filtro-setor">Fila por setor</label>
              <select
                id="filtro-setor"
                value={setorFiltro}
                onChange={(e) => setSetorFiltro(normSetor(e.target.value))}
              >
                {SETORES.map((s) => (
                  <option key={s.value} value={s.value}>
                    {s.label}
                  </option>
                ))}
              </select>
              <span className="tag-meu-setor">
                Meu setor: <b>{setorUsuario}</b>
              </span>
            </div>

            <div className="busca-operacional">
              <label htmlFor="busca-chamado">Busca na fila</label>
              <input
                id="busca-chamado"
                type="search"
                value={termoBusca}
                onChange={(e) => setTermoBusca(e.target.value)}
                placeholder="Cliente, licença, técnico, descrição..."
              />
            </div>

            {abaAtiva === "filaTecnicos" && (
              <div className="tecnico-filter">
                <label htmlFor="filtro-tecnico-fila">Visualizar técnico</label>
                <select
                  id="filtro-tecnico-fila"
                  value={tecnicoFiltroFila}
                  onChange={(e) => setTecnicoFiltroFila(e.target.value)}
                >
                  <option value="TODOS">Todos os técnicos</option>
                  {tecnicosDisponiveis.map((tec) => (
                    <option key={tec} value={tec}>
                      {tec}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <label className="desc-switch">
              <input
                type="checkbox"
                checked={descSempreVisivel}
                onChange={(e) => setDescSempreVisivel(e.target.checked)}
              />
              <span>Descrições sempre visíveis</span>
            </label>

            {abaAtiva === "filaTecnicos" && (
              <div className="tecnico-stats-inline">
                {tecnicoStats.length === 0 ? (
                  <span className="tecnico-chip muted">Sem distribuição</span>
                ) : (
                  tecnicoStats.map((tec) => (
                    <span className="tecnico-chip" key={tec.nome}>
                      {tec.nome} <b>{tec.total}</b>
                    </span>
                  ))
                )}
              </div>
            )}
          </section>
        )}

        {kpis.criticos > 0 && abaAtiva === "pendentes" && (
          <section className="alerta-operacional alerta-prod">
            <div>
              <strong>{kpis.criticos}</strong> chamado(s) crítico(s) ou
              aguardando há muito tempo.
            </div>
            <button
              type="button"
              onClick={() => {
                setFiltroRapido("CRITICOS");
                setSortConfig({ key: "slaScore", direction: "desc" });
              }}
            >
              Ver todos
            </button>
          </section>
        )}

        <section className="lista-chamados-card lista-prod">
          <div className="lista-chamados-header">
            <div>
              <h2>
                {abaAtiva === "pendentes"
                  ? `Fila ${setorFiltro}`
                  : abaAtiva === "atendendo"
                    ? "Meus atendimentos"
                    : "Distribuição dos técnicos"}
              </h2>
              <p>
                Mostrando {sortedChamados.length} de {chamadosBase.length}{" "}
                chamado(s).
              </p>
            </div>

            <button
              type="button"
              className="btn btn-ordenar-sla"
              onClick={() =>
                setSortConfig({ key: "slaScore", direction: "desc" })
              }
            >
              Ordenar por SLA
            </button>
          </div>

          <div className="chamados-mobile-list" aria-label="Lista de chamados em cards">
            {sortedChamados.length === 0 ? (
              <div className="mobile-empty-state">
                Nenhum chamado encontrado para os filtros atuais.
              </div>
            ) : (
              sortedChamados.map(renderChamadoMobileCard)
            )}
          </div>

          <div className="table-wrapper chamados-table-wrapper">
            <table className="chamados-table chamados-table-modern chamados-table-prod">
              <thead>
                <tr>
                  <th>
                    <button
                      className={`th-sort ${
                        sortConfig.key === "urgencia"
                          ? `sorted-${sortConfig.direction}`
                          : ""
                      }`}
                      onClick={() => requestSort("urgencia")}
                    >
                      Prioridade {renderSortCaret("urgencia")}
                    </button>
                  </th>

                  <th>
                    <button
                      className={`th-sort ${
                        sortConfig.key === "slaScore"
                          ? `sorted-${sortConfig.direction}`
                          : ""
                      }`}
                      onClick={() => requestSort("slaScore")}
                    >
                      SLA {renderSortCaret("slaScore")}
                    </button>
                  </th>

                  <th>
                    <button
                      className={`th-sort ${
                        sortConfig.key === "RazaoSocial"
                          ? `sorted-${sortConfig.direction}`
                          : ""
                      }`}
                      onClick={() => requestSort("RazaoSocial")}
                    >
                      Licença / Cliente {renderSortCaret("RazaoSocial")}
                    </button>
                  </th>

                  {showAtendente && (
                    <th>
                      <button
                        className={`th-sort ${
                          sortConfig.key === "TecAtendimento"
                            ? `sorted-${sortConfig.direction}`
                            : ""
                        }`}
                        onClick={() => requestSort("TecAtendimento")}
                      >
                        Técnico {renderSortCaret("TecAtendimento")}
                      </button>
                    </th>
                  )}

                  <th>
                    <button
                      className={`th-sort ${
                        sortConfig.key === "Func"
                          ? `sorted-${sortConfig.direction}`
                          : ""
                      }`}
                      onClick={() => requestSort("Func")}
                    >
                      Aberto por {renderSortCaret("Func")}
                    </button>
                  </th>

                  <th>
                    <button
                      className={`th-sort ${
                        sortConfig.key === "Data"
                          ? `sorted-${sortConfig.direction}`
                          : ""
                      }`}
                      onClick={() => requestSort("Data")}
                    >
                      Abertura {renderSortCaret("Data")}
                    </button>
                  </th>

                  <th className="col-servidor">
                    <button
                      className={`th-sort ${
                        sortConfig.key === "ServidorWeb"
                          ? `sorted-${sortConfig.direction}`
                          : ""
                      }`}
                      onClick={() => requestSort("ServidorWeb")}
                    >
                      Sistema {renderSortCaret("ServidorWeb")}
                    </button>
                  </th>

                  <th>Ações</th>
                </tr>
              </thead>

              <tbody>
                {sortedChamados.length === 0 ? (
                  <tr className="empty-row">
                    <td colSpan={totalColunasTabela}>
                      Nenhum chamado encontrado para os filtros atuais.
                    </td>
                  </tr>
                ) : (
                  sortedChamados.map((chamado) => {
                    const id =
                      chamado.id ?? `${chamado.ChvCad}-${chamado.Data}`;
                    const aberta = linhasAbertas.has(id);
                    const urgencia = Number(chamado.urgencia) || 0;
                    const sla = chamado.sla || getSlaInfo(chamado);

                    return (
                      <React.Fragment key={id}>
                        <tr
                          className={`row-top ticket-row urg-${urgencia} sla-${sla.status} ${
                            aberta ? "open" : ""
                          }`}
                          onClick={() =>
                            isCollapsible ? toggleLinha(id) : undefined
                          }
                        >
                          <td className="priority-cell">
                            <span className={`priority-bar urg-${urgencia}`} />
                            <div className="urg-cell">
                              <span className={`urg-dot urg-${urgencia}`} />
                              <span>{URG_LABEL[urgencia] || "—"}</span>
                            </div>
                          </td>

                          <td>
                            <div className={`sla-badge sla-${sla.status}`}>
                              <strong>{sla.tempo}</strong>
                              <span>{sla.label}</span>
                            </div>
                          </td>

                          <td className="cliente-cell cliente-cell-reorganizada">
                            <span className="cliente-licenca">
                              Licença: {getLicencaChamado(chamado)}
                            </span>
                            {isRetornoProjeto(chamado) && (
                              <span className="badge-retorno-projeto">
                                Retorno do projeto #{getProjetoOrigemChamado(chamado)}
                              </span>
                            )}
                            <strong className="cliente-fantasia">
                              {getFantasiaChamado(chamado)}
                            </strong>
                            <span className="cliente-razao">
                              {getRazaoChamado(chamado)}
                            </span>
                          </td>

                          {showAtendente && (
                            <td>
                              <span
                                className={
                                  normStr(chamado.TecAtendimento)
                                    ? "tecnico-nome"
                                    : "sem-tecnico"
                                }
                              >
                                {chamado.TecAtendimento || "Sem dono"}
                              </span>
                            </td>
                          )}

                          <td>{chamado.Func || "—"}</td>
                          <td>
                            {chamado.Data || "—"}
                            {chamado.Hora || chamado.hora
                              ? ` às ${chamado.Hora || chamado.hora}`
                              : ""}
                          </td>

                          <td className="col-servidor">
                            <ServidorBadge value={chamado.ServidorWeb} />
                          </td>

                          <td className="acoes-cell">
                            {abaAtiva === "pendentes" && (
                              <button
                                className="btn btn-pegar-row"
                                disabled={!canTakeFromCurrentQueue || isAcaoChamadoLoading}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (!canTakeFromCurrentQueue) return;
                                  localStorage.setItem(
                                    "idChamadoSelecionado",
                                    chamado.id,
                                  );
                                  handlePegarChamado(chamado.id);
                                }}
                              >
                                Pegar
                              </button>
                            )}

                            <button
                              className="btn btn-icon-row"
                              title="Ver descrições"
                              onClick={async (e) => {
                                e.stopPropagation();
                                await handleVerificarDescricoes(chamado);
                              }}
                            >
                              Ver
                            </button>

                            <button
                              className="btn btn-icon-row"
                              title="Histórico"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleAbrirHistorico(
                                  chamado.ChvCad || chamado.CodigoCad,
                                );
                              }}
                            >
                              Hist.
                            </button>
                          </td>
                        </tr>

                        <tr
                          className={`row-bottom ticket-detail-row ${
                            descSempreVisivel || aberta ? "open" : ""
                          }`}
                        >
                          <td
                            colSpan={totalColunasTabela}
                            className="descricao-cell"
                          >
                            <div className="descricao-row descricao-row-com-acoes">
                              <div className="descricao-conteudo">
                                <span className="descricao-label">
                                  Descrição principal:
                                </span>
                                <span className="descricao-text">
                                  {chamado.DescrAtend || "—"}
                                </span>
                              </div>

                              <button
                                type="button"
                                className="btn btn-ver-descricoes-row"
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  await handleVerificarDescricoes(chamado);
                                }}
                              >
                                Ver todas as descrições
                              </button>
                            </div>

                            {abaAtiva === "pendentes" && sla.semDono && (
                              <div
                                className={`sem-dono-alert sla-${sla.status}`}
                              >
                                Chamado sem responsável há {sla.tempo}.
                              </div>
                            )}
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="footer-status">
            {abaAtiva === "pendentes"
              ? `${chamadosPendentes.length} chamados pendentes (${setorFiltro})`
              : abaAtiva === "atendendo"
                ? `${chamadosEmAtendimento.length} em atendimento`
                : `${chamadosFilaTecnicos.length} na fila dos técnicos`}
          </div>
        </section>

        {chamadoSelecionado && detalhesChamado && (
          <div
            className="modal-overlay"
            onClick={() => {
              setChamadoSelecionado(null);
              setIsIntervindo(false);
            }}
          >
            <div
              className="modal-chamado-detalhes modal-chamado-modern"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="DivHeadDetalhes modal-header-modern">
                <div className="headerDetalhes">
                  <span>Atendimento</span>
                  <h2>Detalhes do chamado</h2>
                </div>

                <button
                  className="btn fechar-chamado-detalhes"
                  onClick={() => {
                    setChamadoSelecionado(null);
                    setIsIntervindo(false);
                  }}
                >
                  ×
                </button>
              </div>

              {isRetornoProjeto(detalhesChamado.chamado) && (
                <div className="chamado-origem-projeto-banner">
                  <div>
                    <span>Retorno de projeto</span>
                    <strong>
                      Projeto #{getProjetoOrigemChamado(detalhesChamado.chamado)}
                    </strong>
                  </div>
                  <div>
                    <span>Chamado original</span>
                    <strong>
                      #{detalhesChamado.chamado.ID_CHAMADO_PAI || "—"}
                    </strong>
                  </div>
                  <div>
                    <span>Ciclo</span>
                    <strong>
                      {detalhesChamado.chamado.NR_CICLO_PROJETO || 1}
                    </strong>
                  </div>
                </div>
              )}

              <div className="info-bloco info-bloco-modern">
                <div className="info-item">
                  <strong>Protocolo:</strong>{" "}
                  {detalhesChamado.chamado.Protocolo || "—"}
                </div>
                <div className="info-item">
                  <strong>Contato:</strong>{" "}
                  {detalhesChamado.chamado.nomeContato || "—"}
                </div>
                <div className="info-item">
                  <strong>Telefone:</strong>{" "}
                  {detalhesChamado?.chamado?.telefones || "—"}
                </div>
                <div className="info-item">
                  <strong>Chave do cadastro:</strong>{" "}
                  {detalhesChamado.chamado.chvCad || "—"}
                </div>
                <div className="info-item">
                  <strong>Razão social:</strong>{" "}
                  {detalhesChamado.chamado.RazaoSocial || "—"}
                </div>
                <div className="info-item">
                  <strong>Tipo de sistema:</strong>{" "}
                  <ServidorBadge
                    value={
                      detalhesChamado?.chamado?.ServidorWeb ??
                      chamadoSelecionado?.ServidorWeb
                    }
                  />
                </div>
                <div className="info-item">
                  <strong>Licença:</strong>{" "}
                  {detalhesChamado.chamado.ChvCad || "—"}
                </div>
                <div className="info-item">
                  <strong>Descrição inicial:</strong>{" "}
                  {detalhesChamado.chamado.descrAtend || "—"}
                </div>
                <div className="info-item">
                  <strong>Problema:</strong>{" "}
                  {detalhesChamado.chamado.identificaProblemaAtend || "—"}
                </div>
                <div className="info-item">
                  <strong>Solução parcial:</strong>{" "}
                  {detalhesChamado.chamado.SolucaoAtend || "—"}
                </div>
                <div className="info-item">
                  <strong>Aberto por:</strong>{" "}
                  {detalhesChamado.chamado.AbertoPor || "—"}
                </div>
                <div className="info-item">
                  <strong>Abertura:</strong>{" "}
                  {detalhesChamado.chamado.DataAbertura
                    ? `${detalhesChamado.chamado.DataAbertura} ${
                        detalhesChamado.chamado.HoraAbertura ||
                        detalhesChamado.chamado.hora ||
                        detalhesChamado.chamado.Hora ||
                        ""
                      }`
                    : "—"}
                </div>
              </div>

              <div className="modal-actions-historico">
                <button
                  className="btn hitorico"
                  id="bt-historico"
                  onClick={() =>
                    handleAbrirHistorico(detalhesChamado.chamado.chvCad)
                  }
                >
                  Ver histórico completo
                </button>

                <button
                  className="btn incluir"
                  id="bt-incluir"
                  onClick={handleAbrirDescricao}
                >
                  Incluir descrição
                </button>

                {isAdmin && !isRetornoProjeto(detalhesChamado.chamado) && (
                  <button
                    type="button"
                    className="btn btn-converter-projeto"
                    onClick={() => setModalConverterProjetoAberto(true)}
                  >
                    Converter em projeto
                  </button>
                )}

                {isRetornoProjeto(detalhesChamado.chamado) &&
                  (textoIgual(
                    detalhesChamado.chamado.TecAtendimento,
                    funcionario,
                  ) ||
                    isAdmin) && (
                    <button
                      type="button"
                      className="btn btn-resultado-retorno"
                      onClick={() => setModalResultadoRetornoAberto(true)}
                    >
                      Registrar retorno ao cliente
                    </button>
                  )}
              </div>

              {podeMoverSetor && setoresDestinoPermitidos.length > 0 && (
                <section className="setor-transfer-panel">
                  <div className="setor-transfer-copy">
                    <span>Encaminhamento entre setores</span>
                    <strong>Direcionar chamado para outra fila</strong>
                    <small>
                      Usuários do suporte podem encaminhar demandas ao Financeiro
                      sem precisar assumir o chamado.
                    </small>
                  </div>

                  <div className="setor-transfer-actions">
                    <select
                      value={setorDestinoChamado}
                      onChange={(event) =>
                        setSetorDestinoChamado(event.target.value)
                      }
                    >
                      <option value="">Selecione o setor</option>
                      {setoresDestinoPermitidos
                        .filter(
                          (item) =>
                            item.value !==
                            normSetor(
                              detalhesChamado.chamado.Setor ??
                                chamadoSelecionado?.Setor,
                            ),
                        )
                        .map((item) => (
                          <option key={item.value} value={item.value}>
                            {item.label}
                          </option>
                        ))}
                    </select>
                    <button
                      type="button"
                      className="btn-mover-setor"
                      disabled={!setorDestinoChamado || isSubmittingSetor}
                      onClick={handleRedirecionarSetor}
                    >
                      {isSubmittingSetor
                        ? "Encaminhando..."
                        : "Encaminhar setor"}
                    </button>
                  </div>
                </section>
              )}

              {textoIgual(detalhesChamado.chamado.TecAtendimento, funcionario) && (
                <>
                  <div className="redirect-wrapper">
                    <label>
                      <strong>Redirecionar para:</strong>
                    </label>
                    <select
                      value={tecnicoDestino}
                      onChange={(e) => setTecnicoDestino(e.target.value)}
                    >
                      <option value="">Selecione um técnico</option>
                      {tecnicosDisponiveis.map((tec, idx) => (
                        <option key={idx} value={tec}>
                          {tec}
                        </option>
                      ))}
                    </select>
                    <button
                      className="btn-redirecionar"
                      disabled={!tecnicoDestino || isAcaoChamadoLoading}
                      onClick={() => handleRedirecionarChamado(tecnicoDestino)}
                    >
                      Confirmar redirecionamento
                    </button>
                  </div>

                  <div className="divLiberar">
                    <button
                      className="btn-liberar"
                      disabled={isAcaoChamadoLoading}
                      onClick={handleLiberarChamado}
                    >
                      Liberar chamado
                    </button>
                  </div>
                </>
              )}

              {isAdmin && abaAtiva === "filaTecnicos" && (
                <>
                  {!isIntervindo && (
                    <div className="divIntervir">
                      <button
                        className="btn btn-adm-intervir"
                        onClick={handleAbrirIntervencao}
                      >
                        Intervir como ADM
                      </button>
                    </div>
                  )}

                  {isIntervindo && (
                    <div className="intervencao-panel">
                      <h3>Intervenção ADM</h3>

                      <div className="intervencao-row">
                        <label>Ação:</label>
                        <select
                          value={acaoIntervencao}
                          onChange={(e) => setAcaoIntervencao(e.target.value)}
                        >
                          <option value="ASSUMIR">Assumir chamado</option>
                          <option value="REDIRECIONAR">
                            Redirecionar para outro técnico
                          </option>
                          <option value="LIBERAR">
                            Liberar para fila geral
                          </option>
                          <option value="FINALIZAR">Finalizar chamado</option>
                        </select>
                      </div>

                      {acaoIntervencao === "REDIRECIONAR" && (
                        <div className="intervencao-row">
                          <label>Técnico destino:</label>
                          <select
                            value={tecnicoDestinoAdm}
                            onChange={(e) =>
                              setTecnicoDestinoAdm(e.target.value)
                            }
                          >
                            <option value="">Selecione um técnico</option>
                            {tecnicosDisponiveis.map((tec, idx) => (
                              <option key={idx} value={tec}>
                                {tec}
                              </option>
                            ))}
                          </select>
                        </div>
                      )}

                      <div className="intervencao-row">
                        <label>Descrição da intervenção:</label>
                        <textarea
                          rows={3}
                          value={descricaoIntervencao}
                          onChange={(e) =>
                            setDescricaoIntervencao(e.target.value)
                          }
                          placeholder="Explique o motivo e o que foi feito..."
                        />
                      </div>

                      <div className="intervencao-actions">
                        <button
                          className="btn confirmar"
                          onClick={handleConfirmarIntervencao}
                          disabled={isSubmittingIntervencao}
                        >
                          {isSubmittingIntervencao
                            ? "Aplicando..."
                            : "Confirmar intervenção"}
                        </button>
                        <button
                          className="btn fechar"
                          onClick={() => setIsIntervindo(false)}
                          disabled={isSubmittingIntervencao}
                        >
                          Cancelar
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}

              <div className="historico-wrapper">
                <div className="historico-title">
                  <h3>Histórico do atendimento</h3>
                  <span>
                    {(detalhesChamado.historico || []).length} registro(s)
                  </span>
                </div>

                <table className="historico-table">
                  <thead>
                    <tr>
                      <th>Descrição</th>
                      <th>Data</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detalhesChamado.historico.length === 0 ? (
                      <tr>
                        <td
                          colSpan={2}
                          style={{ textAlign: "center", color: "#888" }}
                        >
                          Nenhuma descrição registrada.
                        </td>
                      </tr>
                    ) : (
                      detalhesChamado.historico.map((h, idx) => (
                        <tr key={idx}>
                          <td>{h.descricao}</td>
                          <td>{new Date(h.data).toLocaleString()}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>

              {detalhesChamado.chamado.TecAtendimento === funcionario && (
                <div className="divBtns">
                  <button
                    className="btn finalizar"
                    onClick={handleFinalizarChamado}
                    disabled={isSubmittingFinalizar}
                  >
                    {isSubmittingFinalizar
                      ? "Finalizando..."
                      : "Finalizar chamado"}
                  </button>
                </div>
              )}
            </div>
          </div>
        )}

        {descricaoModalAberto && (
          <div
            className="modal-overlay"
            onClick={() => setDescricaoModalAberto(false)}
          >
            <div
              className="modal-content modal-nova-descricao"
              onClick={(e) => e.stopPropagation()}
            >
              <h2>Nova descrição</h2>
              <textarea
                rows={4}
                value={novaDescricao}
                onChange={(e) => setNovaDescricao(e.target.value)}
                placeholder="Digite a nova descrição do atendimento..."
              />
              <div className="modal-actions">
                <button
                  className="btn incluir"
                  onClick={handleSalvarDescricao}
                  disabled={isSubmittingDescricao}
                >
                  {isSubmittingDescricao ? "Salvando..." : "Salvar"}
                </button>

                <button
                  className="btn fechar"
                  onClick={() => setDescricaoModalAberto(false)}
                >
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        )}
        {confirmacaoNovoChamado && (
          <div
            className="modal-confirmacao-chamado-container"
            onClick={cancelarAberturaNovoChamado}
          >
            <div
              className="modal-confirmacao-chamado"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-confirmacao-header">
                <div>
                  <span className="confirmacao-eyebrow">Pré-validação do atendimento</span>
                  <h2>Atenção antes de abrir o chamado</h2>
                </div>

                <button
                  type="button"
                  className="btn-fechar-confirmacao"
                  onClick={cancelarAberturaNovoChamado}
                  title="Fechar"
                  aria-label="Fechar"
                >
                  ×
                </button>
              </div>

              <p className="confirmacao-texto">
                Foram identificados pontos que merecem atenção para{" "}
                <strong>
                  {confirmacaoNovoChamado.cliente?.RazaoSocial || "o cliente selecionado"}
                </strong>
                . Isso não bloqueia o atendimento.
              </p>

              <div className="confirmacao-alertas-grid">
                {Number(confirmacaoNovoChamado.qtdParcelasAtrasadas || 0) > 0 && (
                  <div className="confirmacao-alerta-card financeiro">
                    <span className="confirmacao-alerta-icone" aria-hidden="true">
                      !
                    </span>
                    <div>
                      <strong>
                        {confirmacaoNovoChamado.qtdParcelasAtrasadas || 0}{" "}
                        {Number(confirmacaoNovoChamado.qtdParcelasAtrasadas) === 1
                          ? "parcela em atraso"
                          : "parcelas em atraso"}
                      </strong>
                      <p>
                        {Number(confirmacaoNovoChamado.qtdParcelasEmAberto || 0) > 0
                          ? `${confirmacaoNovoChamado.qtdParcelasEmAberto} parcela(s) também constam em aberto no período. `
                          : ""}
                        O aviso é informativo e não bloqueia o atendimento.
                      </p>
                    </div>
                  </div>
                )}

                {(confirmacaoNovoChamado.chamados || []).length > 0 && (
                  <div className="confirmacao-alerta-card chamado">
                    <span className="confirmacao-alerta-icone" aria-hidden="true">
                      !
                    </span>
                    <div>
                      <strong>
                        {(confirmacaoNovoChamado.chamados || []).length}{" "}
                        {(confirmacaoNovoChamado.chamados || []).length === 1
                          ? "chamado já aberto"
                          : "chamados já abertos"}
                      </strong>
                      <p>
                        Verifique se a nova solicitação pode ser tratada no chamado
                        existente para evitar duplicidade.
                      </p>
                    </div>
                  </div>
                )}
              </div>

              {(confirmacaoNovoChamado.chamados || []).length > 0 && (
                <div className="confirmacao-chamados-lista">
                  {(confirmacaoNovoChamado.chamados || [])
                    .slice(0, 5)
                    .map((chamado, idx) => {
                      const idChamado =
                        chamado.id || chamado.ID || `cliente-chamado-${idx}`;

                      return (
                        <div key={idChamado} className="confirmacao-chamado-item">
                          <div className="confirmacao-chamado-topo">
                            <strong>Chamado #{idChamado}</strong>
                            <span
                              className={`confirmacao-status ${
                                String(
                                  chamado.statusChamado ||
                                    chamado.StatusChamado ||
                                    "0",
                                ) === "1"
                                  ? "status-finalizado"
                                  : "status-aberto"
                              }`}
                            >
                              {String(
                                chamado.statusChamado ||
                                  chamado.StatusChamado ||
                                  "0",
                              ) === "1"
                                ? "Finalizado"
                                : "Aberto"}
                            </span>
                          </div>

                          <span className="confirmacao-descricao">
                            {chamado.descricao ||
                              chamado.DescrAtend ||
                              chamado.descrAtend ||
                              "Sem descrição inicial."}
                          </span>

                          <small>
                            Técnico:{" "}
                            {chamado.tecnico ||
                              chamado.TecAtendimento ||
                              "Fila geral"}
                            {" | "}
                            Data: {chamado.data || chamado.Data || "—"}
                            {chamado.hora || chamado.Hora
                              ? ` às ${chamado.hora || chamado.Hora}`
                              : ""}
                          </small>
                        </div>
                      );
                    })}
                </div>
              )}

              <p className="confirmacao-pergunta">
                Revise os alertas acima e escolha como deseja continuar.
              </p>

              <div className="modal-actions">
                <button
                  type="button"
                  className="btn fechar"
                  onClick={cancelarAberturaNovoChamado}
                >
                  Voltar
                </button>

                <button
                  type="button"
                  className="btn incluir"
                  onClick={confirmarAberturaNovoChamado}
                >
                  Continuar para novo chamado
                </button>
              </div>
            </div>
          </div>
        )}
      </main>

      {mostrarModalParcelas && (
        <ModalParcelas
          onClose={() => setMostrarModalParcelas(false)}
          parcelas={parcelasCliente}
        />
      )}

      {mostrarModalPlanos && (
        <ModalPlanos
          onClose={() => setMostrarModalPlanos(false)}
          planos={planosCliente}
        />
      )}

      {mostrarModalNumeroSerie && (
        <ModalNumeroSerie
          isOpen={true}
          onClose={() => setmostrarModalNumeroSerie(false)}
          codigoCadastro={clienteSelecionado?.CodigoCad}
        />
      )}

      {modalHistoricoAberto && codigoHistoricoCliente && (
        <ModalHistoricoChamados
          isOpen={modalHistoricoAberto}
          onClose={() => {
            setModalHistoricoAberto(false);
            setCodigoHistoricoCliente(null);
          }}
          codigoCadastro={codigoHistoricoCliente}
        />
      )}

      {modalNovoChamadoAberto && (
        <NovoChamadoModal
          clienteInicial={clienteSelecionado}
          onClose={() => setModalNovoChamadoAberto(false)}
          onSuccess={async (resultado = {}) => {
            const tecnicoCriado = normStr(
              resultado?.TecAtendimento ||
                resultado?.tecAtendimento ||
                resultado?.tecnico ||
                resultado?.tecnicoDestino,
            );

            const statusCriado = normStr(
              resultado?.StatusChamado || resultado?.status,
            ).toUpperCase();

            const abriuEmAtendimento = Boolean(
              resultado?.emAtendimento ||
                tecnicoCriado ||
                statusCriado === "EM ATENDIMENTO",
            );

            const setorCriado = normSetor(
              resultado?.setor ||
                resultado?.Setor ||
                resultado?.setorDestino ||
                setorFiltro,
            );

            setModalNovoChamadoAberto(false);
            setAgoraTick(Date.now());

            if (abriuEmAtendimento) {
              setAbaAtiva("atendendo");
              await fetchTudoPorSetor(setorFiltro);
            } else {
              setAbaAtiva("pendentes");

              if (setorCriado !== setorFiltro) {
                setSetorFiltro(setorCriado);
              }

              await fetchTudoPorSetor(setorCriado);
            }

            setSortConfig({
              key: "slaScore",
              direction: "desc",
            });
          }}
        />
      )}

      {mostrarModalTolerancia && (
        <ModalDataTolerancia
          isOpen={true}
          onClose={() => setMostrarModalTolerancia(false)}
          codigoCadastro={clienteSelecionado?.CodigoCad}
        />
      )}

      <ModalConverterChamadoProjeto
        isOpen={modalConverterProjetoAberto}
        onClose={() => setModalConverterProjetoAberto(false)}
        chamado={{
          ...chamadoSelecionado,
          ...(detalhesChamado?.chamado || {}),
        }}
        funcionarioAdm={funcionario}
        codFuncAdm={getSessionValue("codFunc", "CodFunc", "CODFUNC")}
        nivelAdm={nivelUsuario}
        onSuccess={async () => {
          setModalConverterProjetoAberto(false);
          setChamadoSelecionado(null);
          setDetalhesChamado(null);
          localStorage.removeItem("idChamadoSelecionado");
          await fetchTudo();
        }}
      />

      <ModalResultadoRetornoProjeto
        isOpen={modalResultadoRetornoAberto}
        onClose={() => setModalResultadoRetornoAberto(false)}
        chamado={{
          ...chamadoSelecionado,
          ...(detalhesChamado?.chamado || {}),
        }}
        funcionario={funcionario}
        codFunc={getSessionValue("codFunc", "CodFunc", "CODFUNC")}
        onSuccess={async (resultado) => {
          setModalResultadoRetornoAberto(false);
          const permaneceAberto =
            String(resultado?.resultado || "").toUpperCase() ===
            "SEM_CONTATO";

          if (permaneceAberto && chamadoSelecionado?.id) {
            await fetchDetalhesChamado(chamadoSelecionado.id);
          } else {
            setChamadoSelecionado(null);
            setDetalhesChamado(null);
            localStorage.removeItem("idChamadoSelecionado");
          }

          await fetchTudo();
        }}
      />
    </MainLayout>
  );
};

export default Chamados;
